<div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center">
        <h1>Business Detail</h1>
        <div class="float-end">
            <mat-checkbox [(ngModel)]="isLauncherAvailable" (change)="onLauncherToggle($event)">Enable
                Launcher</mat-checkbox>&nbsp;&nbsp;
            <mat-checkbox [(ngModel)]="isWatermarkEnabled" (change)="onWatermarkToggle($event)">Enable
                Watermark</mat-checkbox>&nbsp;┊&nbsp;
            <button mat-flat-button color="danger" (click)="onCancel()"><mat-icon>arrow_back</mat-icon>Cancel</button>
        </div>
    </div>
    <div class="card overflow-auto" appDynamicHeight [offset]="140" [minHeight]="300">
        @if (business) {
        <div class="row p-0 m-0">
            <div class="container p-3 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="d-flex justify-content-between align-items-center pb-1">
                    <div class="fw-bold fs-6 p-2">Business Detail</div>
                    <div>
                        <button mat-raised-button color="warn" class="ms-2" (click)="openDeleteBusinessDialog()">
                            <mat-icon>delete</mat-icon>
                            Delete Business
                        </button>
                        <button mat-raised-button color="primary" class="ms-2" (click)="openUpdateSubscriptionDialog()">
                            <mat-icon>upgrade</mat-icon>
                            Update Subscription
                        </button>
                    </div>
                </div>

                <hr />

                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <th>Business Name</th>
                            <td>
                                @if (!isEditingBusinessName) {
                                <span>{{ business.name }}</span>
                                <mat-icon class="edit-pencil-icon ms-2" (click)="startEditBusinessName()" role="button"
                                    tabindex="0" title="Edit Business Name">edit</mat-icon>
                                } @else {
                                <div class="d-flex align-items-center gap-1 business-name-edit-box w-100">
                                    <input type="text" class="business-name-input flex-grow-1"
                                        [(ngModel)]="editedBusinessName" (keyup.enter)="saveBusinessName()"
                                        (keyup.escape)="cancelEditBusinessName()" [disabled]="isSavingBusinessName"
                                        placeholder="Enter business name" autofocus />
                                    <button type="button" class="action-btn save-btn"
                                        [disabled]="isSavingBusinessName || !editedBusinessName.trim()"
                                        (click)="saveBusinessName()" title="Save Business Name"
                                        aria-label="Save Business Name">
                                        @if (isSavingBusinessName) {
                                        <span class="spinner-border spinner-border-sm" role="status"></span>
                                        } @else {
                                        <mat-icon>check</mat-icon>
                                        }
                                    </button>
                                    <button type="button" class="action-btn cancel-btn"
                                        [disabled]="isSavingBusinessName" (click)="cancelEditBusinessName()"
                                        title="Cancel" aria-label="Cancel">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                                }
                            </td>
                        </tr>
                        <tr>
                            <th>Business Admin Email</th>
                            <td>{{ business.business_admin_email }}</td>
                        </tr>
                        <tr>
                            <th>Created At</th>
                            <td>{{ business.created_at | dateFormat }}</td>
                        </tr>
                        <tr>
                            <th>Expiry Date</th>
                            <td>{{ business.expiry_date | dateFormat }}</td>
                        </tr>
                        <tr>
                            <th>Status</th>
                            <td>{{ business.status | uppercase }}</td>
                        </tr>
                        <tr>
                            <th>Is Active</th>
                            <td>{{ business.is_active ? 'Yes' : 'No' }}</td>
                        </tr>
                        <tr>
                            <th>Members Limit</th>
                            <td>{{ business.members_limit }}</td>
                        </tr>
                        <tr>
                            <th>Screen Limit</th>
                            <td>{{ business.screen_limit }}</td>
                        </tr>
                        <tr>
                            <th>Storage Limit</th>
                            <td>{{ business.storage_limit | bytesToReadable }}</td>
                        </tr>
                        <tr>
                            <th>Validity Period</th>
                            <td>{{ business.validity_period | daysToDuration }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="container p-3 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="d-flex justify-content-between align-items-center pb-1">
                    <div class="fw-bold fs-6 p-2">Billing Address</div>
                    <div class="position-absolute end-0">
                        @if(!isEditBillingAddress){<button mat-raised-button color="primary" class="ms-2 me-3"
                            (click)="onStartEditBillingAddress()"><mat-icon>edit</mat-icon>Edit Billing Addres</button>}
                    </div>
                </div>
                <hr />


                @if (!isEditBillingAddress) {
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <th>Full Name</th>
                            <td>{{ billingAddress.full_name }}</td>
                        </tr>
                        <tr>
                            <th>Address 1</th>
                            <td>{{ billingAddress.address_1 }}</td>
                        </tr>
                        <tr>
                            <th>Address 2</th>
                            <td>{{ billingAddress.address_2 }}</td>
                        </tr>
                        <tr>
                            <th>Country</th>
                            <td>{{ billingAddress.country_name }}</td>
                        </tr>
                        <tr>
                            <th>State</th>
                            <td>{{ billingAddress.state_name }}</td>
                        </tr>
                        <tr>
                            <th>City</th>
                            <td>{{ billingAddress.city }}</td>
                        </tr>
                        <tr>
                            <th>ZIP Code</th>
                            <td>{{ billingAddress.zip_code }}</td>
                        </tr>
                        <tr>
                            <th>Mobile Number</th>
                            <td>{{ billingAddress.mobile_number }}</td>
                        </tr>
                    </tbody>
                </table>
                }
                @else {
                <form class="row" [formGroup]="billingAddressForm" (ngSubmit)="onSaveBillingAddress()">

                    <mat-form-field appearance="outline" class="col-12">
                        <mat-label>Full Name</mat-label>
                        <input matInput formControlName="full_name" required />
                        @if(billingAddressForm.controls['full_name'].invalid){<mat-error>Full Name is
                            required</mat-error>}
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="col-6">
                        <mat-label>Address 1</mat-label>
                        <input matInput formControlName="address_1" required />
                        @if(billingAddressForm.controls['address_1'].invalid){<mat-error>Address 1 is
                            required</mat-error>}
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="col-6">
                        <mat-label>Address 2</mat-label>
                        <input matInput formControlName="address_2" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="col-6">
                        <mat-label>Country</mat-label>
                        <mat-select formControlName="country" placeholder="Select country">
                            <mat-option value="">Select</mat-option>
                            @for (country of countries; track $index){
                            <mat-option [value]="country.id">{{ country.name }}</mat-option>
                            }

                        </mat-select>
                        @if(billingAddressForm.get('country')?.hasError('required')){<mat-error>Country is
                            required</mat-error>}
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="col-6">
                        <mat-label>State</mat-label>
                        <mat-select formControlName="state" placeholder="Select state" [disabled]="states.length === 0">
                            <mat-option value="">Select</mat-option>
                            @for (state of states; track $index) {
                            <mat-option [value]="state.id">{{ state.name }}</mat-option>
                            }
                        </mat-select>
                        @if(billingAddressForm.get('state')?.hasError('required')){<mat-error>State is
                            required</mat-error>}
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="col-6">
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city" required />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="col-6">
                        <mat-label>ZIP Code</mat-label>
                        <input matInput formControlName="zip_code" required />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="col-6">
                        <mat-label>Mobile Number</mat-label>
                        <input matInput formControlName="mobile_number" />
                        @if(billingAddressForm.get('mobile_number')?.hasError('pattern')){<mat-error>Invalid mobile
                            number format</mat-error>}
                    </mat-form-field>

                    <div class="d-flex justify-content-end col-6 p-3">
                        <button matButton type="button"
                            (click)="isEditBillingAddress = false"><mat-icon>close</mat-icon>Cancel</button>
                        <button matButton type="submit"> <mat-icon>save</mat-icon>Save</button>
                    </div>
                </form>
                }


            </div>
            <hr />
            <div class="container p-3 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="d-flex justify-content-between align-items-center pb-2 position-relative">
                    <div class="fw-bold fs-6 p-2">Users</div>
                    <!-- <button matButton class="position-absolute end-0" (click)="onGenerateInvoice()">Generate Invoice</button> -->
                </div>
                <!-- <hr class="p-0 m-0" /> -->
                <div class="card overflow-auto" appDynamicHeight [offset]="920" [minHeight]="200">
                    <table mat-table [dataSource]="usersDataSource" class="mat-elevation-z8">

                        <!-- Serial Number Column -->
                        <ng-container matColumnDef="serial_no">
                            <th mat-header-cell *matHeaderCellDef> # </th>
                            <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
                        </ng-container>

                        <!-- Full Name -->
                        <ng-container matColumnDef="full_name">
                            <th mat-header-cell *matHeaderCellDef>Full Name</th>
                            <td mat-cell *matCellDef="let element"> {{element.full_name}} </td>
                        </ng-container>

                        <!-- Role -->
                        <ng-container matColumnDef="is_admin">
                            <th mat-header-cell *matHeaderCellDef>Role</th>
                            <td mat-cell *matCellDef="let element">
                                {{element.is_admin ?'Admin':( element?.role_name?element.role_name:'-' )}}
                            </td>
                        </ng-container>

                        <!-- Email -->
                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef>Email</th>
                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                        </ng-container>

                        <!-- Email Verified -->
                        <ng-container matColumnDef="is_email_verified">
                            <th mat-header-cell *matHeaderCellDef>Email Verified</th>
                            <td mat-cell *matCellDef="let element">
                                {{element.is_email_verified ? 'Yes' : 'No'}}
                            </td>
                        </ng-container>

                        <!-- Is Active -->
                        <ng-container matColumnDef="is_active">
                            <th mat-header-cell *matHeaderCellDef>Active</th>
                            <td mat-cell *matCellDef="let element">
                                {{element.is_active ? 'Yes' : 'No'}}
                            </td>
                        </ng-container>

                        <!-- Eye Icon Button Column -->
                        <ng-container matColumnDef="action_button">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex justify-content-end">
                                    <button class="cursor-pointer me-3" mat-icon-button [matMenuTriggerFor]="userMenu"
                                        aria-label="More actions">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #userMenu="matMenu">
                                        <button mat-menu-item (click)="impersonateUser(element)"
                                            [disabled]="element.is_payment_done || element.is_void">
                                            <mat-icon>login</mat-icon>
                                            <span>Log In as This User</span>
                                        </button>
                                    </mat-menu>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedUserColumns"
                            class="position-sticky top-0 z-index-500"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedUserColumns;"></tr>
                    </table>
                </div>
            </div>
            <div class="container p-3 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="d-flex justify-content-between align-items-center pb-2 position-relative">
                    <div class="fw-bold fs-6 p-2">Custom Invoices</div>
                    <button mat-raised-button color="primary" class="position-absolute end-0"
                        (click)="onGenerateInvoice()"><mat-icon>receipt</mat-icon>Generate Invoice</button>
                </div>
                <!-- <hr class="p-0 m-0" /> -->
                <div class="card overflow-auto" appDynamicHeight [offset]="920" [minHeight]="200">
                    <table mat-table [dataSource]="customInvoiceDataSource" class="mat-elevation-z8">

                        <!-- Serial Number Column -->
                        <ng-container matColumnDef="serial_no">
                            <th mat-header-cell *matHeaderCellDef> # </th>
                            <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
                        </ng-container>

                        <!-- Invoice Number -->
                        <ng-container matColumnDef="invoice_number">
                            <th mat-header-cell *matHeaderCellDef>Invoice Number</th>
                            <td mat-cell *matCellDef="let element"> {{element.invoice_number}} </td>
                        </ng-container>

                        <!-- Status -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element"> {{element.status | uppercase}} </td>
                        </ng-container>

                        <!-- Paid -->
                        <!-- <ng-container matColumnDef="is_payment_done">
                            <th mat-header-cell *matHeaderCellDef>Paid</th>
                            <td mat-cell *matCellDef="let element"> {{element.is_payment_done?'Yes':'No'}} </td>
                        </ng-container> -->

                        <!-- Cancelled -->
                        <!-- <ng-container matColumnDef="is_void">
                            <th mat-header-cell *matHeaderCellDef>Cancelled</th>
                            <td mat-cell *matCellDef="let element"> {{element.is_void?'Yes':'No'}} </td>
                        </ng-container> -->

                        <!-- Cancelled -->
                        <!-- <ng-container matColumnDef="is_void">
                            <th mat-header-cell *matHeaderCellDef>Cancelled</th>
                            <td mat-cell *matCellDef="let element"> {{element.is_void?'Yes':'No'}} </td>
                        </ng-container> -->


                        <!-- Invoice Date -->
                        <ng-container matColumnDef="invoice_date">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Invoice Date</th>
                            <td mat-cell *matCellDef="let element" class="text-center"> {{element.invoice_date |
                                dateFormat }} </td>
                        </ng-container>

                        <!-- Create -->
                        <ng-container matColumnDef="created_at">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Created</th>
                            <td mat-cell *matCellDef="let element" class="text-center"> {{element.created_at |
                                dateFormat }} </td>
                        </ng-container>

                        <!-- Eye Icon Button Column -->
                        <ng-container matColumnDef="action_button">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex justify-content-end">
                                    <button class="cursor-pointer me-3" mat-icon-button
                                        [matMenuTriggerFor]="invoiceMenu" aria-label="More actions">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #invoiceMenu="matMenu">
                                        <button mat-menu-item (click)="downloadInvoice(element)">
                                            <mat-icon>download</mat-icon>
                                            <span>Download</span>
                                        </button>
                                        <button mat-menu-item (click)="editInvoice(element)"
                                            [disabled]="element.is_payment_done || element.is_void || element.is_send_copy">
                                            <mat-icon>edit</mat-icon>
                                            <span>Edit</span>
                                        </button>
                                        <button mat-menu-item (click)="sendACopy(element)" [disabled]="element.is_void">
                                            <mat-icon>email</mat-icon>
                                            <span>Send a Copy</span>
                                        </button>
                                        <button mat-menu-item (click)="sendReceiptMail(element)"
                                            [disabled]="!element.is_payment_done">
                                            <mat-icon>email</mat-icon>
                                            <span>Send Receipt</span>
                                        </button>
                                        <button mat-menu-item (click)="cancelInvoice(element)"
                                            [disabled]="element.is_void || element.is_payment_done">
                                            <mat-icon>block</mat-icon>
                                            <span>Cancel</span>
                                        </button>
                                        <button mat-menu-item (click)="markAsPaid(element)"
                                            [disabled]="element.is_payment_done || element.is_void">
                                            <mat-icon>check_circle</mat-icon>
                                            <span>Mark as Paid</span>
                                        </button>
                                        <!-- <button mat-menu-item (click)="deleteInvoice(element)">
                                            <mat-icon>delete</mat-icon>
                                            <span>Delete</span>
                                        </button> -->
                                    </mat-menu>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedInvoiceColumns"
                            class="position-sticky top-0 z-index-500"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedInvoiceColumns;"></tr>
                    </table>
                </div>
            </div>
        </div>
        }
        @else {
        <div>Loading...</div>
        }
    </div>
</div>

<ng-template #deleteConfirmDialogTemplate>
    <h2 mat-dialog-title>Confirm Delete</h2>
    <mat-dialog-content class="mat-typography">
        <p>Are you sure you want to delete the invoice?</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button matButton [mat-dialog-close]="false" cdkFocusInitial> <mat-icon>cancel</mat-icon> No</button>
        <button matButton [mat-dialog-close]="true"> <mat-icon>check</mat-icon> Yes</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #markAsPaidConfirmDialogTemplate>
    <h2 mat-dialog-title>Payment Confirmation!</h2>
    <mat-dialog-content class="mat-typography">
        <p>Are you sure you want to mark this invoice as paid?</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button matButton [mat-dialog-close]="false" cdkFocusInitial><mat-icon>cancel</mat-icon> No</button>
        <button matButton [mat-dialog-close]="true"> <mat-icon>check</mat-icon> Yes</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #sendCopyConfirmDialogTemplate>
    <h2 mat-dialog-title>Send a Copy!</h2>
    <mat-dialog-content class="mat-typography">
        <p>Are you sure you want to send a copy of the invoice to {{business.business_admin_email}}?</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button matButton [mat-dialog-close]="false" cdkFocusInitial><mat-icon>cancel</mat-icon> No</button>
        <button matButton [mat-dialog-close]="true"> <mat-icon>check</mat-icon> Yes</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #sendReceiptConfirmDialogTemplate>
    <h2 mat-dialog-title>Send Receipt Copy!</h2>
    <mat-dialog-content class="mat-typography">
        <p>Are you sure you want to send a copy of the receipt to {{business.business_admin_email}}?</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button matButton [mat-dialog-close]="false" cdkFocusInitial><mat-icon>cancel</mat-icon> No</button>
        <button matButton [mat-dialog-close]="true"> <mat-icon>check</mat-icon> Yes</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #cancelInvoiceConfirmDialogTemplate>
    <h2 mat-dialog-title>Invoice Cancellation!</h2>
    <mat-dialog-content class="mat-typography">
        <p>Are you sure you want to cancel this invoice? It will no longer be valid for payment or accounting purpose.
        </p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button matButton [mat-dialog-close]="false" cdkFocusInitial><mat-icon>cancel</mat-icon> No</button>
        <button matButton [mat-dialog-close]="true"> <mat-icon>check</mat-icon> Yes</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #downloadInvoiceConfirmDialogTemplate>
    <h2 mat-dialog-title>Confirm Invoice Download?</h2>
    <mat-dialog-content class="mat-typography">
        <p>Once downloaded, this invoice will become readonly and cannot be edited. Do you want to continue?</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button matButton [mat-dialog-close]="false" cdkFocusInitial><mat-icon>cancel</mat-icon> No</button>
        <button matButton [mat-dialog-close]="true"> <mat-icon>check</mat-icon> Yes</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #impersonateUserConfirmDialogTemplate>
    <h2 mat-dialog-title>Login confirmation!</h2>
    <mat-dialog-content class="mat-typography">
        <p>
            You are about to log in as this user. A new browser tab will open, and you will be automatically
            authenticated, allowing you to securely access and act on behalf of the selected account.
        </p>
        <p>
            Do you want to continue?
        </p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false" cdkFocusInitial><mat-icon>cancel</mat-icon> No</button>
        <button mat-button color="primary" [mat-dialog-close]="true"><mat-icon>check</mat-icon> Yes</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #changePlanDialogTemplate>
    <h2 mat-dialog-title>Update Subscription</h2>

    <mat-dialog-content>

        <!-- Expiry Date -->
        <mat-form-field appearance="outline" class="w-100 pt-2">
            <mat-label>Expiry Date</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="planForm.expiryDate" [min]="minExpiryDate">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <hr />

        <!-- Screens -->
        <div class="mb-3">
            <label class="form-label">Screens</label>
            <input type="number" class="form-control" [(ngModel)]="planForm.screens" [min]="minScreens"
                [max]="maxScreens" (input)="onPlanChange()" />

            <input type="range" class="form-range mt-2" [(ngModel)]="planForm.screens" [min]="minScreens"
                [max]="maxScreens" (input)="onPlanChange()" />
        </div>

        <!-- Summary -->
        <div class="bg-light p-3 rounded">
            <div class="d-flex justify-content-between"><span>Screens</span><span>{{ planSummary.screens }}</span></div>
            <div class="d-flex justify-content-between"><span>Users</span><span>{{ planSummary.users }}</span></div>
            <div class="d-flex justify-content-between"><span>Storage</span><span>{{ planSummary.storageGb }} GB</span>
            </div>
            <div class="d-flex justify-content-between"><span>Validity (days)</span><span>{{ planSummary.validityDays
                    }}</span></div>
            <div class="d-flex justify-content-between"><span>Per Screen Rate</span><span>{{ planSummary.perScreenRate |
                    currency:'INR' }}</span></div>

            <hr />

            <div class="d-flex justify-content-between fw-semibold">
                <span>Base Amount ({{ planSummary.screens }} × {{ planSummary.perScreenRate | currency:'INR' }})</span>
                <span>{{ planSummary.baseAmount | currency:'INR' }}</span>
            </div>

            <div class="d-flex justify-content-between">
                <span>GST (18%)</span>
                <span>{{ planSummary.gstAmount | currency:'INR' }}</span>
            </div>

            <div class="d-flex justify-content-between fs-6 fw-bold mt-2">
                <span>Total Amount</span>
                <span>{{ planSummary.totalAmount | currency:'INR' }}</span>
            </div>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close><mat-icon>close</mat-icon>Cancel</button>
        <button mat-flat-button color="primary" (click)="confirmUpdateSubscription()"><mat-icon>save</mat-icon>Save
            Changes</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #deleteBusinessConfirmDialogTemplate>
    <h2 mat-dialog-title class="text-danger d-flex align-items-center gap-2 mt-4">
        <mat-icon color="warn">warning</mat-icon>
        Delete Business
    </h2>

    <mat-dialog-content class="mat-typography ms-2">

        <p class="fw-semibold mb-1">
            This action cannot be undone.
        </p>

        <p class="text-muted mb-3">
            Deleting this business will permanently remove all related data including users,
            screens, invoices, playlists, media, and schedules.
        </p>

        <!-- Timer Box (Custom UI) -->
        @if (deleteCountdown > 0) {
        <div class="delete-timer-box text-center p-3 rounded">
            <div class="timer-number">{{ deleteCountdown }}</div>
            <div class="timer-label">Please wait before confirming</div>
        </div>
        } @else {
        <div class="text-success text-center fw-semibold mt-2">
            ✔ You can now delete
        </div>
        }

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="false">
            <mat-icon>close</mat-icon> Cancel
        </button>

        <button mat-flat-button color="warn" [disabled]="deleteCountdown > 0" (click)="confirmDeleteBusiness()">
            <mat-icon>delete</mat-icon>
            Confirm Delete
        </button>
    </mat-dialog-actions>
</ng-template>